import { render, staticRenderFns } from "./Subtree.vue?vue&type=template&id=1faff4c9&"
import script from "./Subtree.vue?vue&type=script&lang=js&"
export * from "./Subtree.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports